import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import { accreditationStatuses, kycStatuses } from 'entoro-shared';

const VerificationStatus = ({
  accreditationStatus,
  kycStatus,
  accreditationType,
}) => {
  let accreditationStatusStyle;
  let kycStatusStyle;

  if (accreditationStatus === 'NOT_STARTED') {
    accreditationStatusStyle = 'grey';
  } else if (accreditationStatus === 'PENDING_APPROVAL') {
    accreditationStatusStyle = 'yellow';
  } else if (accreditationStatus === 'DENIED') {
    accreditationStatusStyle = 'red';
  } else if (
    accreditationStatus === 'EXEMPTED' ||
    accreditationStatus === 'APPROVED'
  ) {
    accreditationStatusStyle = 'green';
  }

  if (kycStatus === 'NOT_STARTED') {
    kycStatusStyle = 'grey';
  } else if (kycStatus === 'UNDER_REVIEW') {
    kycStatusStyle = 'yellow';
  } else if (kycStatus === 'ACCEPTED') {
    kycStatusStyle = 'green';
  } else if (kycStatus === 'REJECTED') {
    kycStatusStyle = 'red';
  }

  return (
    <Fragment>
      <div className='option-container'>
        <div className='_26-black accredidation'>
          {startCase(accreditationType.toLowerCase())} Verification
        </div>
        <div className='grey-regular accreditation'>Accreditation Status</div>
        <div className={`grey-regular ${accreditationStatusStyle}`}>
          {accreditationStatuses.getLabel(accreditationStatus)}
        </div>
        <br />
        <div className='grey-regular accreditation'>
          KYC Verification Status
        </div>
        <div className={`grey-regular ${kycStatusStyle}`}>
          {kycStatuses.getLabel(kycStatus)}
        </div>
      </div>
      <div className='column-fields w-row' style={{ marginBottom: '0px' }}>
        <div className='column-4 w-col w-col-6' />
        <div className='column-5 w-col w-col-6' />
      </div>
    </Fragment>
  );
};

VerificationStatus.propTypes = {
  accreditationStatus: PropTypes.string.isRequired,
  kycStatus: PropTypes.string.isRequired,
  accreditationType: PropTypes.string.isRequired,
};

export default VerificationStatus;



// WEBPACK FOOTER //
// ./src/components/Account/InvestorVerification/VerificationStatus.js